import { useState, useEffect } from "react";
import "./index.css";
import ScannerModal from "../ScannerModal";
import { ScreenSizeConfiguration } from "../../../utils/configurationProvider";
import SVGComponent from "../../_utils/SVGComponent";

import { getRefreshTokenNew } from "../../../redux/features/refreshToken/refreshToken";
import { useDispatch } from "react-redux";

const TotpDownloadApp = ({
  isAppDownload,
  setIsAppDownload,
  isScannerOpen,
  setIsScannerOpen,
}) => {
  const [defaultStore, setDefaultStore] = useState("appstore");
  const [url, setUrl] = useState([]);
  const [appType, setAppType] = useState({ name: "", icon: "" });
  const [isMobile, setIsMobile] = useState(
    window.innerWidth <= ScreenSizeConfiguration.mobileScreen,
  );
  const [windowWidth, setWindowWidth] = useState(window.innerWidth);
  const dispatch = useDispatch();

  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth <= ScreenSizeConfiguration.mobileScreen);
      setWindowWidth(window.innerWidth);
    };
    window.addEventListener("resize", handleResize);
    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, [window.innerWidth]);

  useEffect(() => {
    const handleVisibilityChange = () => {
      if (document.visibilityState === "visible") {
      }
    };

    window.addEventListener("visibilitychange", handleVisibilityChange);

    return () => {
      window.removeEventListener("visibilitychange", handleVisibilityChange);
    };
  }, [dispatch]);

  return (
    <div
      className={`totp-top-main ${isMobile ? "z-z-index-overlay" : "mt-margin-base"}`}
    >
      <div style={{ zIndex: !isScannerOpen && "var(--z-index-content)" }}>
        {isScannerOpen && (
          <div
            className="fixed top-top-base left-left-base w-screen h-screen z-z-index-overlay "
            style={{
              backgroundColor: "var(--primary-black)",
              opacity: "var(--dark-opacity)",
            }}
          ></div>
        )}
        <ScannerModal
          isScannerOpen={isScannerOpen}
          setIsScannerOpen={setIsScannerOpen}
          url={url}
          setUrl={setUrl}
          appType={appType}
          setAppType={setAppType}
          defaultStore={defaultStore}
        />
      </div>
      <div className="divide-totp">
        <div className="totp-download-left">
          <h4 className="font-semibold text-font-md text-text-primary mb-margin-xs">
            Download An Authentication App
          </h4>
          <p className="text-text-secondary mb-margin-md text-font-xs">
            Install a TOTP-compatible authenticator app on your mobile, tablet
            or desktop device this will generate TOTP code which will be
            required for registration and then every time you login.
          </p>
          <p className=" text-text-secondary mb-margin-sm text-font-xs">
            You can download any of the authentication apps listed below, or opt
            for any other app that supports TOTP.
          </p>
          <div className="totp_download_left_4 ">
            <div className="totp-download-dropdown-section">
              <div
                onClick={() => {
                  setUrl([
                    "https://play.google.com/store/apps/details?id=com.google.android.apps.authenticator2&hl=en_IN&pli=1",
                    "https://apps.apple.com/us/app/google-authenticator/id388497605",
                  ]);
                  setAppType({
                    name: "Google Authenticator",
                    icon: "https://q2pay.in/new_assets/common/settings/google_authenticator.svg",
                  });
                  setIsScannerOpen(true);
                  setDefaultStore("playstore");
                }}
                className="cursor-pointer flex flex-row items-center justify-between py-padding-sm px-padding-sm google_auth relative z-z-index-base global-hover-white hover:rounded-border-radius-md"
              >
                <div className="flex gap-gap-sm items-center">
                  <img
                    src={
                      "https://q2pay.in/new_assets/common/settings/google_authenticator.svg"
                    }
                    alt="GoogleAuth"
                    className="w-icon-sm h-icon-sm"
                  />
                  <h4 className="font-normal text-xs text-text-primary">
                    Google Authenticator
                  </h4>
                </div>

                <SVGComponent
                  url={
                    "https://q2pay.in/new_assets/common/arrows/arrow_right_white.svg"
                  }
                  color="var(--text-primary)"
                  height={"var(--icon-sm)"}
                  width={"var(--icon-sm)"}
                />
              </div>
              <div
                onClick={() => {
                  setUrl([
                    "https://play.google.com/store/apps/details?id=com.azure.authenticator&hl=en_IN",
                    "https://apps.apple.com/us/app/microsoft-authenticator/id983156458",
                  ]);
                  setAppType({
                    name: "Microsoft Authenticator",
                    icon: "https://q2pay.in/new_assets/common/settings/microsoft_authenticator.svg",
                  });
                  setIsScannerOpen(true);
                  setDefaultStore("playstore");
                }}
                className="cursor-pointer flex flex-row items-center justify-between py-padding-sm px-padding-sm google_auth relative z-z-index-base global-hover-white hover:rounded-border-radius-md"
              >
                <div className="flex gap-gap-sm items-center">
                  <img
                    src={
                      "https://q2pay.in/new_assets/common/settings/microsoft_authenticator.svg"
                    }
                    alt="GoogleAuth"
                    className="w-icon-sm h-icon-sm"
                  />
                  <h4 className="font-normal text-xs text-text-primary">
                    Microsoft Authenticator
                  </h4>
                </div>
                <SVGComponent
                  url={
                    "https://q2pay.in/new_assets/common/arrows/arrow_right_white.svg"
                  }
                  color="var(--text-primary)"
                  height={"var(--icon-sm)"}
                  width={"var(--icon-sm)"}
                />
              </div>
              <div
                onClick={() => {
                  setUrl([
                    "https://play.google.com/store/apps/details?id=com.lastpass.lpandroid&hl=en_IN",
                    "https://apps.apple.com/us/app/lastpass-password-manager/id324613447",
                  ]);
                  setAppType({
                    name: "LastPass",
                    icon: "https://q2pay.in/new_assets/common/settings/lastpass.svg",
                  });
                  setIsScannerOpen(true);
                  setDefaultStore("playstore");
                }}
                className="cursor-pointer flex flex-row items-center justify-between py-padding-sm px-padding-sm google_auth relative z-z-index-base global-hover-white hover:rounded-border-radius-md"
              >
                <div className="flex gap-gap-sm items-center">
                  <img
                    src={
                      "https://q2pay.in/new_assets/common/settings/lastpass.svg"
                    }
                    alt="GoogleAuth"
                    className="w-icon-sm h-icon-sm"
                  />
                  <h4 className="font-normal text-xs text-text-primary">
                    LastPass
                  </h4>
                </div>
                <SVGComponent
                  url={
                    "https://q2pay.in/new_assets/common/arrows/arrow_right_white.svg"
                  }
                  color="var(--text-primary)"
                  height={"var(--icon-sm)"}
                  width={"var(--icon-sm)"}
                />
              </div>
              <div
                onClick={() => {
                  setUrl([
                    "https://play.google.com/store/apps/details?id=dev.msfjarvis.aps&hl=en",
                    "https://apps.apple.com/us/app/passwords/id6473799789",
                  ]);
                  setAppType({
                    name: "Passwords",
                    icon: "https://q2pay.in/new_assets/common/settings/apple_passwords.svg",
                  });
                  setIsScannerOpen(true);
                  setDefaultStore("appstore");
                }}
                className="cursor-pointer flex flex-row items-center justify-between py-padding-sm px-padding-sm google_auth relative z-z-index-base global-hover-white hover:rounded-border-radius-md"
              >
                <div className="flex gap-gap-sm items-center">
                  <img
                    src={
                      "https://q2pay.in/new_assets/common/settings/apple_passwords.svg"
                    }
                    alt="ApplePassword"
                    className="w-icon-sm h-icon-sm"
                  />
                  <h4 className="font-normal text-xs text-text-primary">
                    Passwords
                  </h4>
                </div>
                <SVGComponent
                  url={
                    "https://q2pay.in/new_assets/common/arrows/arrow_right_white.svg"
                  }
                  color="var(--text-primary)"
                  height={"var(--icon-sm)"}
                  width={"var(--icon-sm)"}
                />
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="divide-totp">
        <div className="totp-download-right">
          <SVGComponent
            url={"https://q2pay.in/new_assets/graphics/totp/download.svg"}
            height={"var(--graphic-square-height-md)"}
            width={"var(--graphic-width-md)"}
          />
          <div
            className="totp-download-right-button bg-primary-nav hover:bg-primary-nav-act global-hover-white"
            onClick={() => {
              setIsAppDownload(!isAppDownload);
            }}
          >
            <img
              src={
                isAppDownload === true
                  ? "https://q2pay.in/new_assets/common/approval/selected_with_green_circle.svg"
                  : "https://q2pay.in/new_assets/common/view_all/not_selected_with_grey_circle.svg"
              }
            />
            <div className="totp-download-right-button-info">
              <h4>Confirm Download</h4>
              <p>I have downloaded the app.</p>
            </div>
          </div>
        </div>
        <div className="h-pagination-height"></div>
      </div>
    </div>
  );
};

export default TotpDownloadApp;
